export const SCALEFLEX_CLOUDIMG_URL = 'https://scaleflex.cloudimg.io/v7/'
